import Vue from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import echarts from 'echarts'
import './assets/css/base.css'

import '@/assets/js/directives'

import '@/apis/axiosConfig'

import china from 'echarts/map/json/china.json' // 引入json文件
echarts.registerMap('china', china) // 在echarts中注册使用这个文件

import common from '@/assets/js/common.js'  //公用js
Vue.prototype.$common = common



//图字体大小
if (window.screen.width <= 5760&&window.screen.width > 3840) {
  Vue.prototype.$echartsFontSize = 28
}else if (window.screen.width <= 3840&&window.screen.width > 2560) {
  Vue.prototype.$echartsFontSize = 24
}else if(window.screen.width <= 2560&&window.screen.width > 2048){
  Vue.prototype.$echartsFontSize = 16
}else if(window.screen.width <= 2048&&window.screen.width > 1920){
  Vue.prototype.$echartsFontSize = 9
}else if(window.screen.width <= 1920&&window.screen.width > 1680){
  Vue.prototype.$echartsFontSize = 12
}else if(window.screen.width <= 1680&&window.screen.width > 1366){
  Vue.prototype.$echartsFontSize = 12
}


Vue.prototype.$echarts = echarts
Vue.use(ElementUI);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
